import { PropsWithChildren } from 'react';

export const PrivateRideLayout = ({ children }: PropsWithChildren<unknown>) => {
  return <>{children}</>;
};
